export const REPORTS_LOAD_START = 'REPORTS_LOAD_START';
export const REPORTS_LOAD_SUCCESS = 'REPORTS_LOAD_SUCCESS';
export const REPORTS_LOAD_ERROR = 'REPORTS_LOAD_ERROR';
export const SET_REPORT_FILTER = 'SET_REPORT_FILTER';
export const RESET_REPORT_FILTERS = 'RESET_REPORT_FILTERS';
export const REMOVE_REPORT = 'REMOVE_REPORT';
